<template>
    <div>
        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-users mr-1"></i> Turmas
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                        <!-- Create -->
                        <button type="button" class="btn btn-primary ml-sm-auto mr-auto mr-sm-0 mt-3 mt-sm-0" v-b-modal.create>
                            Criar Turma
                        </button>

                        <create :endpoint="endpointStore" :external-link-group="externalLinkGroup" :telegram-by-group="telegramByGroup" :telegram="telegram" @created="load"></create>

                    </div>
                </div>
            </div>
        </div>

        <!-- Container -->
        <div class="container">
            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Código">
                        <b-form-input
                            v-model="filter.code"
                            placeholder="Buscar por código ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-5">
                    <!-- Field -->
                    <b-form-group label="Nome">
                        <b-form-input
                            v-model="filter.name"
                            placeholder="Buscar por nome ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>

                
            </div>
            
            
            
            <b-card class="mb-4">
                <!-- Load Table -->
                <b-skeleton-wrapper :loading="loading">

                    <!-- Loading -->
                    <template #loading>
                        <b-skeleton-table
                            :rows="lastResultsCount"
                            :columns="5"
                            :table-props="{ bordered: true, striped: false }"
                        >
                        </b-skeleton-table>
                    </template>

                    <div class="alert alert-info d-flex justify-content-between align-items-center" v-if="selected.length > 0">

                        <div>
                            Você está selecionando <b>{{ selected.length }}</b> turmas.
                        </div>
    
                        <div>
                            <b-dropdown text="Ações" variant="primary" right>
                                <b-dropdown-item @click="selectCreditBatch" :disabled="! credit">Alterar Créditos</b-dropdown-item>
                            </b-dropdown>
                        </div>
    
                    </div>

                    <!-- Table -->
                    <b-table
                        id="groupTable"
                        ref="selectableTable"
                        :items="table"
                        :fields.sync="fields"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @sort-changed="changeSortable"
                        empty-text="Não encontramos nenhum resultado na busca :("
                        class="bg-white mb-0"
                        stacked="md"
                        :sticky-header="true"
                        show-empty
                        @row-selected="onRowSelected"
                        select-mode="multi"
                        :selectable="true"
                        no-local-sorting
                        bordered
                        hover>

                        <template v-slot:head(selected)="data">
                            <div class="badge badge-warning" v-b-tooltip.hover title="Agora é possivel realizar a alteração de créditos de todos os alunos da turma clicando no checkbox ao lado do código da turma.">Novo</div>
                            <b-form-checkbox @input="inputSelectAll($event)"></b-form-checkbox>
                        </template>
    
                        <template #cell(selected)="{ rowSelected, index}">
                            <b-form-checkbox
                                v-model="rowSelected"
                                @input="inputSelect($event, index)"
                            ></b-form-checkbox>
                        </template>


                        <template v-slot:cell(code)="row">
                            {{ row.item.code }} <i class="fas fa-sm fa-info-circle ml-1" v-b-tooltip.hover title="Código usado para os alunos se cadastrarem na turma"></i>
                        </template>

                        <template v-slot:cell(open)="row">

                            <span v-if="row.item.open" v-b-tooltip.hover title="Os alunos poderão se matricular nessa turma usando apenas o código da turma">
                                <i class="fas fa-sm fa-circle text-success mr-1"></i>
                                Abertas
                            </span>

                            <span v-else v-b-tooltip.hover title="Os alunos não conseguirão se matricular nessa turma no momento">
                                <i class="fas fa-sm fa-circle mr-1 text-danger"></i>
                                Fechadas
                            </span>

                        </template>

                        <template v-slot:cell(send_essay)="row">

                            <span v-if="row.item.send_essay" v-b-tooltip.hover title="Os alunos poderão enviar redação para a plataforma">
                                <i class="fas fa-sm fa-circle text-success mr-1"></i>
                                Sim
                            </span>

                            <span v-else v-b-tooltip.hover title="Os alunos não poderão enviar redação para a plataforma">
                                <i class="fas fa-sm fa-circle mr-1 text-danger"></i>
                                Não
                            </span>

                        </template>

                        <template v-slot:cell(external_link)="row">
                            <a v-if="row.item.external_link" :href="row.item.external_link" target="_blank" class="text-primary">
                                <i class="fas fa-external-link-alt mr-1"></i>
                                {{ row.item.external_link | truncate(30) }}
                            </a>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(telegram_number)="row">
                            <a v-if="row.item.telegram_number" :href="row.item.telegram_number" target="_blank" class="text-primary">
                                <i class="fas fa-external-link-alt mr-1"></i>
                                {{ row.item.telegram_number | truncate(30) }}
                            </a>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(telegram_enabled)="row">
                            <span v-if="row.item.telegram_enabled" class="text-success">
                                <i class="fas fa-sm fa-circle text-success mr-1"></i>
                                Ativo
                            </span>
                            <span v-else class="text-danger">
                                <i class="fas fa-sm fa-circle mr-1 text-danger"></i>
                                Inativo
                            </span>
                        </template>

                        <template v-slot:cell(themes_count)="row">
                            <a class="text-primary" href="javascript:void(1);" @click="showThemes(row.item)" v-b-tooltip.hover title="Editar Temas">
                                <i class="fas fa-edit"></i>
                            </a>
                            <span v-if="row.item.themes_count > 0">
                                {{ row.item.themes_count }} Temas
                            </span>
                            <span v-else>
                                Todos os Temas
                            </span>
                        </template>

                        <template v-slot:cell(created_at)="row">
                            {{ row.item.created_at | moment('from', 'now') }}
                        </template>

                        <template v-slot:cell(updated_at)="row">
                            {{ row.item.updated_at | moment('from', 'now') }}
                        </template>

                        <template v-slot:cell(integrations)="row">
                            <div v-if="integrationBraip || integrationEduzz || integrationHotmart || integrationKiwify">

                                <span v-if="row.item.course_braip_id || row.item.content_eduzz_id || row.item.course_hotmart || row.item.course_kwify_id" v-b-tooltip.hover title="Uma ou mais das integrações contradas foi configurada">
                                    <i class="fas fa-sm fa-circle text-success mr-1"></i>
                                    Configurado
                                </span>
                                <span v-else class="text-danger" v-b-tooltip.hover title="Nenhuma das integrações contratadas foi configurada ainda">
                                    <i class="fas fa-sm fa-circle mr-1 text-danger"></i>
                                    À configurar
                                </span>
                            </div>
                            <span v-else v-b-tooltip.hover title="Você não possui nenhuma integração">
                                <i class="fas fa-sm fa-circle mr-1 text-info"></i>
                                    Não possui
                            </span>
                        </template>

                        <template v-slot:cell(actions)="row">
                            <div class="text-center">
                                <!-- Details -->
                                <a href="#" @click="showDetail(row.item)" v-b-tooltip.hover title="Detalhes da Turma">
                                    <i class="fas fa-eye"></i>
                                </a>

                                <!-- Transfer -->
                                <a class="ml-2" href="javascript:void(1);" @click="transferGroup(row.item)" v-b-tooltip.hover title="Transferir Alunos">
                                    <i class="fas fa-exchange-alt"></i>
                                </a>

                                <!-- Invitation -->
                                <a class="ml-2" href="#" @click="invitationGroup(row.item)" v-b-tooltip.hover title="Convidar Alunos">
                                    <i class="fas fa-user-plus"></i>
                                </a>
                            </div>
                        </template>

                    </b-table>
                </b-skeleton-wrapper>
            </b-card>

            <!-- Paginate -->
            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />

            <!-- Results -->
            <div class="mb-4">
                {{ total }} resultados encontrados.
            </div>

        </div>

        <!-- Show -->
        <show :endpoint-update="endpointUpdate" :endpoint-destroy="endpointDestroy" :external-link-group="externalLinkGroup" :telegram-by-group="telegramByGroup" :telegram="telegram" :integration-hotmart="integrationHotmart" :integration-eduzz="integrationEduzz" :integration-braip="integrationBraip" :integration-kiwify="integrationKiwify" :payment-stripe="paymentStripe" @load="load"></show>

        <!-- Invitation -->
        <invitation></invitation>

        <!-- Transfer -->
        <transfer @created="load"></transfer>

        <!-- Themes -->
        <themes @updated="load"></themes>


        <!-- Edit Credit Batch -->
        <b-modal
            id="editCreditBatch"
            title="Editar Créditos"
            centered
            hide-footer
        >
            <b-overlay :show="loadingCredit" rounded="sm">

                <div class="alert alert-info d-flex justify-content-between align-items-center">

                    <div>
                        Você está selecionando <b>{{ selected.length }}</b> turmas.
                    </div>

                </div>

                <!-- Field -->
                <b-form-group
                    label="Modo de Alteração"
                    description="Você deseja sobrescrever ou incrementar/decrementar os créditos dos alunos nas turmas selecionadas ?">

                    <!-- Input -->
                    <b-form-radio v-model="formCreditBatch.mode" name="mode" value="inc_or_dec">
                        Quero que os créditos sejam incrementados/decrementados de acordo com a quantidade que os alunos já possuem.
                    </b-form-radio>
                    <b-form-radio v-model="formCreditBatch.mode" name="mode" value="overwrite">
                        Quero que os créditos sejam sobrescritos dos alunos selecionados.
                    </b-form-radio>

                    <!-- Error -->
                    <has-errors :errors="errors" name="mode" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Qtd. de Créditos">

                    <!-- Input -->
                    <b-form-input
                        type="number"
                        :min="0"
                        v-model="formCreditBatch.qtd"
                        :state="hasErrors('qtd', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="qtd" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Data de Vencimento">

                    <!-- Input -->
                    <b-form-datepicker
                        v-model="formCreditBatch.due_date"
                        label-no-date-selected="Nenhuma data selecionada ..."
                        locale="pt-BR">
                    </b-form-datepicker>

                    <!-- Error -->
                    <has-errors :errors="errors" name="due_date" />
                </b-form-group>

                <b-form-group>
                    <b-button type="button" variant="primary" @click="updateCreditBatch" :disabled="loadingCredit">
                        Editar Créditos
                    </b-button>
                </b-form-group>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import Create from "./Create";
import Show from './Show';
import Invitation from "./Invitation";
import Transfer from "./Transfer";
import Themes from "./Themes.vue";

export default {
    components: {
        Create,
        Show,
        Invitation,
        Transfer,
        Themes
    },
    props: ['endpointIndex', 'endpointStore', 'endpointUpdate', 'endpointDestroy', 'externalLinkGroup', 'telegramByGroup', 'telegram', 'integrationHotmart', 'integrationEduzz', 'integrationBraip', 'integrationKiwify', 'credit', 'paymentStripe'],
    data() {
        return {
            loading: false,
            loadingCredit: false,
            table: [],
            perPage: 9,
            currentPage: 1,
            total: 0,
            sortBy: 'name',
            sortDesc: false,
            filter: {
                code: null,
                name: null
            },
            lastResultsCount: 5,
            fields: [
                { key: 'selected' },
                { key: 'code', label: 'Código', sortable: true },
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'students_count', label: 'Nº de Alunos', sortable: true },
                { key: 'open', label: 'Matricula por Código ?', sortable: true },
                { key: 'send_essay', label: 'Alunos poderão enviar redações ?', sortable: true },
                { key: 'integrations', label:'Integrações', sortable: true },
                { key: 'themes_count', label: 'Temas Disponíveis', sortable: true },
                { key: 'actions', label: '' }
            ],
            formCreditBatch: {
                mode: null,
                qtd: null,
                due_date: null
            },
            errors: {},
            selected: [],
        }
    },
    created() {
        this.load()

        if (this.externalLinkGroup) {
            this.fields.splice(3, 0, {
                key: 'external_link', label: 'Link Externo'
            })
            this.fields.join();
        }

        if (this.telegramByGroup) {
            this.fields.splice(4, 0, {
                key: 'telegram_number', label: 'Link Telegram'
            })
            this.fields.join();
        }

        if (this.telegram) {
            this.fields.splice(3, 0, {
                key: 'telegram_enabled', label: 'Link Telegram'
            })
            this.fields.join();
        }

    },
    watch: {
        'filter.code': async function (value) {
            this.filter.code = await value;
            await this.load()
        },
        'filter.name': async function (value) {
            this.filter.name = await value;
            await this.load()
        },
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointIndex, {
                params: {
                    code: this.filter.code,
                    name: this.filter.name,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.groups.data
                    this.currentPage = response.groups.current_page
                    this.perPage = response.groups.per_page
                    this.total = response.groups.total

                    this.lastResultsCount = response.groups.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        showDetail(group) {
            this.$root.$emit('groupsShowDetail', group)
        },

        invitationGroup(group) {
            this.$root.$emit('invitationGroup', group)
        },

        transferGroup(group) {
            this.$root.$emit('transferGroup', group)
        },

        showThemes(group) {
            this.$root.$emit('showThemes', group)
        },

        onRowSelected(items) {
            this.selected = items;
        },

        inputSelect(event, key) {
            if (event) {
                this.$refs.selectableTable.selectRow(key)
            } else {
                this.$refs.selectableTable.unselectRow(key)
            }
        },

        inputSelectAll(event) {
            if (event) {
                this.$refs.selectableTable.selectAllRows()
            } else {
                this.$refs.selectableTable.clearSelected();
            }
        },

        selectCreditBatch() {
            this.formCreditBatch = {
                mode: null,
                qtd: null,
                due_date: null
            };

            this.$bvModal.show('editCreditBatch')
        },
        
        updateCreditBatch() {
            this.loadingCredit = true;
            axios.put('/teacher/students/update-credit-batch', {
                ...this.formCreditBatch,
               
                groups: this.selected.map(obj => JSON.stringify(obj))
            })
                .then((result) => {

                    // Load
                    this.load();

                    this.selected = [];

                    this.errors = {};

                    // Message
                    this.$toast.success('Créditos foram alterados com sucesso !');

                    // Close Modal
                    this.$bvModal.hide('editCreditBatch')
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loadingCredit = false)
        },
    }
}
</script>

<style scoped>

</style>
